import styled from 'styled-components';
import InnerBackground from './InnerBackground';
import OuterBackground from './OuterBackground';

export const BlockColorPickerDiv = styled.div`
    position: relative;
    margin-bottom: 4px;
`;

export const Div = styled.div`
    border: ${({ theme }) => `1px solid ${theme.colors.neutral100}`};
    height: 28px;
    width: 100%;
    margin-top: 5px;
    position: relative;
    cursor: pointer;
`;

export const OuterBackgroundComponent = styled(InnerBackground)`
    box-sizing: border-box;
    position: absolute;
    width: 24px;
    height: 24px;
    left: 2px;
    top: calc(50% - 12px);
`;

export const InnerBackgroundComponent = styled(OuterBackground)`
    box-sizing: border-box;
    position: absolute;
    width: 24px;
    height: 24px;
    left: 2px;
    top: calc(50% - 12px);
`;

export const ColorSpan = styled.span`
    position: absolute;
    font-size: 12px;
    left: 36px;
    bottom: 7px;
    text-transform: uppercase;
`;

export const IconSpan = styled.span`
    position: absolute;
    width: 24px;
    height: 24px;
    right: 4px;
    top: calc(50% - 12px);
`;

export const Icon = styled.i`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 20px;
    width: 20px;
    height: 20px;
    padding: 2px;
`;

export const ColorPickerDiv = styled.div`
    position: absolute;
    z-index: 3;
    top: 31px;
    right: 0px;
`;

export const ColorPicker = styled.div`
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
`;
